module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-70"
  }, [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "pa-5": "",
      "mt-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": "",
      "fill-height": "",
      "mb-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "lg12": "",
      "sm12": "",
      "xs12": "",
      "md10": ""
    }
  }, [_c('div', {
    staticClass: "font-24"
  }, [_vm._v("Contact us")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md10": "",
      "mt-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-3 py-3",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "f-700"
  }, [_vm._v("Existing Investors")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "mt-1 font-12"
  }, [_vm._v("Speak write to "), _c('a', {
    attrs: {
      "href": "mailto:ir@iob.vc"
    }
  }, [_vm._v("ir@iob.vc.")]), _vm._v(" You can also speak directly to our support team "), _c('a', {
    attrs: {
      "href": "https://t.me/iob_llc",
      "target": "_blank"
    }
  }, [_vm._v("via Telegram")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "f-700"
  }, [_vm._v("Potential Investors")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "mt-1 font-12"
  }, [_vm._v("For more information, please write to us at "), _c('a', {
    attrs: {
      "href": "mailto:ir@iob.vc"
    }
  }, [_vm._v("ir@iob.vc")]), _vm._v(". You can find more information about our upcoming TAOs at "), _c('a', {
    attrs: {
      "href": _vm.domainName + '/#/ir'
    }
  }, [_vm._v("Investor Relations")]), _vm._v(".")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "f-700"
  }, [_vm._v("Media & Press")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "mt-1 font-12"
  }, [_vm._v("For our media package, media events or to book a speaking engagement, please email us at "), _c('a', {
    attrs: {
      "href": "mailto:media@iob.vc"
    }
  }, [_vm._v("media@iob.vc")]), _vm._v(".")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-5": "",
      "mb-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md3": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/contact/usa.jpg",
      "height": "300px"
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-start": "",
      "column": ""
    }
  }, [_c('div', {
    staticClass: "white--text pa-3 py-5"
  }, [_c('div', {
    staticClass: "font-14 mt-2"
  }, [_vm._v("\n                                            IOB LLC\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v(" \n                                            1013 Centre Road, Suite 403-A Wilmington, DE 19805, USA (HQ)\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v("\n                                            +1 775 476 8588\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('a', {
    attrs: {
      "href": "mailto:usa@iob.vc"
    }
  }, [_vm._v("usa@iob.vc")])])])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md3": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/contact/shanghai.jpg",
      "height": "300px"
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-start": "",
      "column": ""
    }
  }, [_c('div', {
    staticClass: "white--text pa-3 py-5"
  }, [_c('div', {
    staticClass: "font-14 mt-2"
  }, [_vm._v("\n                                        IOB Shanghai Ltd.\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v(" \n                                        Shanghai, China (Regional HQ)\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v("\n                                        +1 775 476 8588\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('a', {
    attrs: {
      "href": "mailto:china@iob.vc"
    }
  }, [_vm._v("china@iob.vc")])])])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md3": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/contact/germany.jpg",
      "height": "300px"
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-start": "",
      "column": ""
    }
  }, [_c('div', {
    staticClass: "white--text pa-3 py-5"
  }, [_c('div', {
    staticClass: "font-14 mt-2"
  }, [_vm._v("\n                                        IOB Mesh Technology\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v(" \n                                        Hildeboldplatz 15-17, 50672, Cologne, Germany (Regional HQ)\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v("\n                                        +49 172 261 2031\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('a', {
    attrs: {
      "href": "mailto:germany@iob.vc"
    }
  }, [_vm._v("germany@iob.vc")])])])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md3": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/contact/london.jpg",
      "height": "300px"
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-start": "",
      "column": ""
    }
  }, [_c('div', {
    staticClass: "white--text pa-3 py-5"
  }, [_c('div', {
    staticClass: "font-14 mt-2"
  }, [_vm._v("\n                                        IOB London\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v(" \n                                        Hyde House, Edgware Road, London NW9, UK (Investment Services)\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v("\n                                        +44 794 110 9962\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('a', {
    attrs: {
      "href": "mailto:uk@iob.vc"
    }
  }, [_vm._v("uk@iob.vc")])])])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80d2a9e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about/Contact.vue
// module id = 462
// module chunks = 0